import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from "../../header/header.component";
import { FooterComponent } from '../../footer/footer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { MetaTagService } from '../../meta-tag.service';
import { IconsFreeToolsComponent } from '../../icons-free-tools/icons-free-tools.component';


@Component({
  selector: 'app-all-tools',
  standalone: true,
  imports: [RouterModule, HeaderComponent, CommonModule, FormsModule, ReactiveFormsModule, HttpClientModule, FooterComponent, IconsFreeToolsComponent,],
  templateUrl: './all-tools.component.html',
  styleUrl: './all-tools.component.css'
})
export class AllToolsComponent {
  ngOnInit(): void {
    this.metaService.updateTags("Explore All free Tools - Your Complete Toolkit in One Place", "Get all GrammarIn free tools in one place. From productivity to analytics, find the perfect solution for your needs today! ", "https://www.grammarin.com/ai-writing-tools");
  }
  constructor(private metaService: MetaTagService) { }

  tools = [
    {
      link: '/blog-post-generator',
      icon: 'newAiBlogWritingToolIcon',
      title: 'AI Blog Writing  Tool',
      description: 'Creates engaging blog posts on your chosen topics or keywords.',
    },
    {
      link: '/slogan-generator',
      icon: 'newAiSloganGeneratorIcon',
      title: 'AI Slogan  Generator',
      description: 'Generates catchy and brand-aligned slogans or taglines.',
    },
    {
      link: '/instagram-caption-generator',
      icon: 'newAiInstagramCaptionGeneratorIcon',
      title: 'AI Instagram Caption   Generator',
      description: 'Crafts creative and trendy captions for Instagram posts.',
    },
    {
      link: '/ai-article-writer',
      icon: 'newArticleWritingToolIcon',
      title: 'Article Writing   Tool',
      description: 'Helps you write complete articles from scratch with proper structure and tone.',
    },

  ];
  tools1 = [
    {
      link: '/report-writer',
      icon: 'newAiBusinessReportWriterIcon',
      title: 'AI Business Report  Writer',
      description: 'Writes structured business reports from key input data.',
    },
    {
      link: '/value-proposition',
      icon: 'newValuePropositionToolIcon',
      title: 'Value Proposition  Tool',
      description: "Crafts a strong value proposition highlighting your product or service's benefits.",
    },
    {
      link: '/executive-summary',
      icon: 'newExecutiveSummaryToolIcon',
      title: 'Executive Summary  Tool',
      description: 'Summarizes long documents into concise executive summaries.',
    },
    {
      link: '/resignation-letter-generator',
      icon: 'newAiResignationLetterWriteIcon',
      title: 'AI Resignation Letter  Writer',
      description: 'Generates polite and professional resignation letters.',
    },
    {
      link: '/email-writer',
      icon: 'newProfessionalEmailWriterToolIcon',
      title: 'Professional Email   Writer Tool',
      description: 'Helps write clear, effective, and formal emails.',
    },
    {
      link: '/ai-business-plan',
      icon: 'newAiBusinessPlanGeneratorIcon',
      title: 'AI Business Plan  Generator',
      description: 'Builds comprehensive business plans with goals, strategy, and projections.',
    }
  ];
  tools2 = [
    {
      link: '/cover-letter',
      icon: 'newCoverLetterGeneratorIcon',
      title: 'Cover Letter  Generator',
      description: 'Builds personalized cover letters aligned with your resume and job role.',
    },
    {
      link: '/resume-objective-generator',
      icon: 'newAiResumeObjectiveGeneratorIcon',
      title: 'AI Resume Objective   Generator',
      description: 'Creates compelling resume objectives based on your career.',
    },
    {
      link: '/resume-skills',
      icon: 'newAiResumeSkillsGeneratorIcon',
      title: 'AI Resume Skills  Generator',
      description: 'Suggests relevant skills to include in your resume for specific roles.',
    },
    {
      link: '/ai-job-description',
      icon: 'newJobDescriptionGeneratorIcon',
      title: 'Job Description  Generator',
      description: 'Quickly generates detailed job descriptions for open roles.',
    }
  ];
  tools3 = [
    {
      link: '/article-rewriter',
      icon: 'newArticleRewriteIcon',
      title: 'Article  Rewriter',
      description: 'Rewrites articles to create unique versions without changing core meaning.',
    },
    {
      link: '/thesis-statement-generator',
      icon: 'newAiThesisStatementGeneratorIcon',
      title: 'AI Thesis Statement  Generator',
      description: 'Instantly creates strong, clear thesis statements for essays or research papers.',
    },
    {
      link: '/personal-statement-generator',
      icon: 'newAiPersonalStatementGeneratorIcon',
      title: 'AI Personal  Statement Generator',
      description: 'Helps craft compelling personal statements tailored to academic or job applications.',
    },
    {
      link: '/grammar-checker',
      icon: 'newGrammarCheckerIcon',
      title: 'Grammar  Checker',
      description: 'Detects and corrects grammar mistakes in your writing.',
    },
    {
      link: '',
      icon: 'newCitationGeneratorIcon',
      title: 'Citation   Generator',
      description: 'Automatically creates citations in APA, MLA, Chicago, or other formats.',
    },
    {
      link: '/grading',
      icon: 'newIeltsTofelGradingIcon',
      title: 'IELTS / TOFEL   Grading',
      description: 'Evaluates your writing using IELTS/TOEFL-style scoring criteria.',
    },
    {
      link: '/paraphrasing-tool',
      icon: 'newParaphrasingToolIcon',
      title: 'Paraphrasing  Tool',
      description: 'Rewrites text to improve clarity, tone, or originality while retaining meaning.',
    },

    {
      link: '/ai-summarizer',
      icon: 'newTextSummarizerIcon',
      title: 'Text  Summarizer',
      description: 'Condenses long texts into brief, informative summaries.',
    },
    {
      link: '/punctuation-checker',
      icon: 'newPunctuationCheckerIcon',
      title: 'Punctuation   Checker',
      description: 'Identifies and fixes punctuation errors in your text.',
    },
    {
      link: '/sentence-checker',
      icon: 'newSentenceCheckerIcon',
      title: 'Sentence  Checker',
      description: 'Reviews sentence structure and suggests improvements for clarity and flow.',
    },

    {
      link: '/essay-checker',
      icon: 'newEssayCheckerIcon',
      title: 'Essay  Checker',
      description: 'Analyzes essays for grammar, structure, coherence, and writing quality.',
    },
    {
      link: '/online-proofreader',
      icon: 'newOnlineProofreaderIcon',
      title: 'Online  Proofreader',
      description: 'Provides comprehensive proofreading for spelling, grammar, and style issues.',
    },
    // {
    //   link: '/plagiarism-checker',
    //   icon: 'plagiarismCheckerIcon',
    //   title: 'Plagiarism  Checker',
    //   description: '',
    // },




  ];
  tools4 = [
    {
      link: '/ai-paragraph-generator',
      icon: 'newAiParagraphGeneratorIcon',
      title: 'AI Paragraph  Generator',
      description: 'Generates well-structured paragraphs based on your topic or prompt.',
    },
    {
      link: '/aiBrainstorming',
      icon: 'newAiBrainstormingToolIcon',
      title: 'AI Brainstorming  Tool',
      description: 'Provides creative ideas and angles for writing or projects.',
    },
    {
      link: '/ai-letter-writer',
      icon: 'newAiLetterWriterIcon',
      title: 'AI Letter  Writer',
      description: 'Drafts professional or personal letters tailored to your needs.',
    },


    {
      link: '/sentence-rewriter',
      icon: 'newAiSentenceRewriterIcon',
      title: 'AI Sentence  Rewriter',
      description: 'Generates well-structured paragraphs based on your topic or prompt.',
    },
    // {
    //   link: '/paragraph-rewriter',
    //   icon: 'paragraphRewriterIcon',
    //   title: 'AI Paragraph  Rewriter',
    // description: '',
    // },
    // {
    //   link: '/rewording-tool',
    //   icon: 'rewordingToolIcon',
    //   title: 'AI Rewording  Tool',
    //   description: '',
    // }

  ];

}
